import { createSlice } from "@reduxjs/toolkit";

const appSlice = createSlice({
  name: "onlineEvent",
  initialState: {
    isOnlineEventOpen: false,
  },
  reducers: {
    toogleOnlineEvent: (state) => {
      state.isOnlineEventOpen = !state.isOnlineEventOpen;
    },
  },
});

export const { toogleOnlineEvent } = appSlice.actions;
export default appSlice.reducer;